<template>
  <div class="page noselect">

    <!--        <div class="absBack">-->
    <!--            <div onclick="window.history.back()">-->
    <!--                <v-icon  medium dark>mdi-arrow-left</v-icon>-->
    <!--            </div>-->
    <!--        </div>-->


    <h2 class="mt-7 text-center hidden-sm-and-down">
      <span v-if="$store.getters.isKiosk">Letzte </span>
      <span v-else>Meine </span>
      Bestellungen</h2>

    <v-container grid-list-md>
      <h3 class="myTitle text-center" v-if="lastOrders.length === 0">Keine Bestellungen bisher</h3>
      <!--        <div class="text-center">der letzten 60 Tage</div>-->

      <div class="lastOrder pointer" v-for="order in lastOrders" @click.passive="gotoDetails(order)">
        <table class="maxw myTable">
          <tr>
            <td style="width: 100px">#{{ order.orderNumber }}</td>
            <td class="text-left">{{ order.createdAt | dateToString }} Uhr</td>
            <td class="text-right" style="width: 10%">{{ order.paymentInfo.amount | price }}</td>
          </tr>
        </table>
        <div></div>
      </div>


      <div class="spacer-15"></div>

      <div class="text-center">
        <v-btn
          class="btn-df" rounded
          onclick="window.history.back()"
        >
          Zurück
        </v-btn>
        <div class="pt-6">
          <v-btn class="btn-df" rounded
                 @click="updateList">
            <v-icon>mdi-reload</v-icon>
            Aktualisieren
          </v-btn>
        </div>
      </div>

      <div class="spacer-25"></div>

    </v-container>


    <FixBasket></FixBasket>

    <!--        <qsignal class="hide-md"></qsignal>-->


  </div>
</template>

<script>
import store from '../store/store'
import {ebus} from '../vendor/ebus';
import * as util from '@/vendor/util'
import FixBasket from "../components/FixBasket";
// import * as xhr from '../api/xhr.js'
// import * as util from '../vendor/util'
// import * as qconst from '../vendor/qconstants';
// import * as firebaseUtil from '../firebase/firebaseUtil'
// import Qsignal from "../components/qsignal";

export default {
  components: {FixBasket},
  data() {
    return {
      initTime: 0,
    }
  },

  computed: {
    lastOrders() {
      let list = util.cloneMe(store.getters.lastOrders);
      //filter by flags
      return list.filter(o => !o.directPay || (o.authCompleted));
    }
  },

  beforeMount() {
    // if (store.getters.loggedIn === false) {
    //     this.$router.push({name: 'Home'});
    // }
  },

  created() {
    ebus.$on('lastOrdersUpdated', () => {
      // if (this.initTime > 0 && Date.now() - this.initTime > 2000 && this.$route.name === 'Bestellungen') {
      //   ebus.$emit('toast', 'Die Liste der Bestellungen wurde aktualisiert');
      // }
    });
  },

  destroyed() {
    util.clearEvents([
      'lastOrdersUpdated',
    ]);
  },

  mounted() {
    this.initTime = Date.now();
    this.init();
    ebus.$emit('loadLastOrders');
  },

  // activated() {
  //     // store.commit('currentRoute', 'lastOrders');
  //     // if (this.lastOrders.length === 0) {
  //     //load the orders every time the user visits this page
  //     ebus.$emit('loadLastOrders');
  //     // }
  // },

  methods: {
    init() {
    },

    updateList() {
      ebus.$emit('loadLastOrders');
      setTimeout(() => {
        ebus.$emit('toast', 'Die Liste der Bestellungen wurde aktualisiert');
      }, 2000);
    },

    gotoDetails(orderSelected) {
      this.$router.push({name: 'Bestellung', params: {uniqueOrderId: orderSelected.uniqueOrderId}});
    }
  }

}
</script>

<style lang="scss" scoped>
@import '../styles/base';
/*@import '../styles/sharedStyles';*/

.lastOrder {
  margin: 15px 16px;
  background-color: $color-secondary;
  border-left: 6px solid $accent;
  border-radius: $box-border-radius;
  padding: 8px;
  @include material-shadow(1);

  &:hover {
    @include material-shadow(2);
  }
}

.myTable {
  tr {
    td:first-child {
      font-size: 1.2em;
    }
  }


  td {
    padding: 4px;
  }
}

</style>
